import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAggregate = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M15.75 6.75C15.75 8.82107 14.0711 10.5 12 10.5C9.92893 10.5 8.25 8.82107 8.25 6.75C8.25 4.67893 9.92893 3 12 3C14.0711 3 15.75 4.67893 15.75 6.75Z",
			stroke: "currentcolor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.25 16.25C10.25 18.3211 8.57107 20 6.5 20C4.42893 20 2.75 18.3211 2.75 16.25C2.75 14.1789 4.42893 12.5 6.5 12.5C8.57107 12.5 10.25 14.1789 10.25 16.25Z",
			stroke: "currentcolor",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.25 16.25C21.25 18.3211 19.5711 20 17.5 20C15.4289 20 13.75 18.3211 13.75 16.25C13.75 14.1789 15.4289 12.5 17.5 12.5C19.5711 12.5 21.25 14.1789 21.25 16.25Z",
			stroke: "currentcolor",
			strokeWidth: 1.5
		})
	]
});
export default SvgAggregate;
